import { ListItem, Text, UnorderedList } from '@chakra-ui/react'
import type { ReactElement } from 'react'

import type { ListItemWithEmphasis } from './types'

export default function UnorderedListWithEmphasis({
  listItems,
}: {
  listItems: ListItemWithEmphasis[]
}): ReactElement {
  return (
    <UnorderedList>
      {listItems.map(listItem => (
        <ListItem key={listItem.emphasizedText}>
          <Text as="span" fontWeight="bold" color="fg.muted">
            {listItem.emphasizedText}{' '}
          </Text>
          <Text as="span">{listItem.normalText}</Text>
        </ListItem>
      ))}
    </UnorderedList>
  )
}
